import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const Questionnaire = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    company: '',
    question1: '',
    question2: '',
    question3: '',
    question4: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { token } = useAuth();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(
        `${API_URL}/api/zona-pro/questionnaire`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success('¡Cuestionario enviado correctamente! Muchas gracias por tu feedback.');
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        mobile: '',
        company: '',
        question1: '',
        question2: '',
        question3: '',
        question4: ''
      });
      
      // Redirect to dashboard after 2 seconds
      setTimeout(() => {
        navigate('/zona-pro/dashboard');
      }, 2000);
    } catch (error) {
      toast.error('Error enviando cuestionario. Por favor, intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-6 py-4">
          <Button
            onClick={() => navigate('/zona-pro/dashboard')}
            variant="ghost"
            size="sm"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Volver al Dashboard
          </Button>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto px-6 py-12 max-w-3xl">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl font-serif">Cuestionario para Colegas de Profesión</CardTitle>
            <CardDescription className="text-base">
              Me gustaría conocer tu feedback por tu experiencia profesional
            </CardDescription>
          </CardHeader>
          
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-6">
              <p className="text-slate-700">Hola,</p>

              {/* Personal Info */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Nombre *</label>
                  <Input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Tu nombre completo"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Email *</label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="tu@email.com"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Móvil *</label>
                  <Input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="Ej: 623 154 054"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Empresa/Club (Opcional)</label>
                  <Input
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Nombre de tu empresa o club"
                  />
                </div>
              </div>

              <hr className="border-slate-200" />

              {/* Questions */}
              <div className="space-y-5">
                <p className="text-lg font-semibold text-slate-800">Dime…</p>

                <div>
                  <label className="block text-sm font-medium mb-2">
                    1. ¿Hay algún producto, servicio, app o proyecto que te haya aportado algo nuevo para tu desempeño profesional? *
                  </label>
                  <Textarea
                    name="question1"
                    value={formData.question1}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Tu respuesta..."
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">
                    2. ¿Qué mejoras o nuevas funcionalidades sugerirías?
                  </label>
                  <Textarea
                    name="question2"
                    value={formData.question2}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Tu respuesta..."
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">
                    3. ¿Estarías interesado aprovechar algún producto o servicio del portfolio?
                  </label>
                  <Textarea
                    name="question3"
                    value={formData.question3}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Tu respuesta..."
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">
                    4. ¿Algo que me quieras comentar?
                  </label>
                  <Textarea
                    name="question4"
                    value={formData.question4}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Tu respuesta..."
                  />
                </div>
              </div>

              {/* Footer message */}
              <div className="text-center space-y-1 py-4">
                <p className="text-slate-700 font-medium">Muchas gracias.</p>
                <p className="text-slate-700">Joan Monzó</p>
                <p className="text-slate-600">623154054</p>
              </div>

              <Button type="submit" className="w-full" size="lg" disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar Cuestionario'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};